import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'bulkMode',
    'bulkMoveFields',
    'bulkTargetType',
    'bulkVipSelect',
    'bulkResidenceSelect',
    'optionCard',
    'optionDetail',
  ];

  bulkModeChanged(event) {
    const mode = event.target.value;

    // Update card selection styling
    this.optionCardTargets.forEach((card) => {
      const radio = card.querySelector('input[type="radio"]');
      if (radio && radio.value === mode) {
        card.classList.add('border-primary');
      } else {
        card.classList.remove('border-primary');
      }
    });

    // Show/hide detail sections within each card
    this.optionDetailTargets.forEach((detail) => {
      const card = detail.closest(
        '[data-discharge-equipment-target="optionCard"]'
      );
      const radio = card?.querySelector('input[type="radio"]');
      if (radio && radio.value === mode) {
        detail.classList.remove('d-none');
      } else {
        detail.classList.add('d-none');
      }
    });

    // Hide/show bulk move fields (only show for move_all mode)
    if (this.hasBulkMoveFieldsTarget) {
      if (mode === 'move_all') {
        this.bulkMoveFieldsTarget.classList.remove('d-none');
      } else {
        this.bulkMoveFieldsTarget.classList.add('d-none');
      }
    }
  }

  bulkTargetTypeChanged(event) {
    const targetType = event.target.value;

    // Hide and disable both selects
    if (this.hasBulkVipSelectTarget) {
      this.bulkVipSelectTarget.classList.add('d-none');
      const select = this.bulkVipSelectTarget.querySelector('select');
      if (select) {
        select.value = '';
        select.disabled = true;
      }
    }
    if (this.hasBulkResidenceSelectTarget) {
      this.bulkResidenceSelectTarget.classList.add('d-none');
      const select = this.bulkResidenceSelectTarget.querySelector('select');
      if (select) {
        select.value = '';
        select.disabled = true;
      }
    }

    // Show and enable the appropriate select
    if (targetType === 'Vip' && this.hasBulkVipSelectTarget) {
      this.bulkVipSelectTarget.classList.remove('d-none');
      const select = this.bulkVipSelectTarget.querySelector('select');
      if (select) select.disabled = false;
      this.#enableChoicesListsPlaceholder(this.bulkVipSelectTarget);
    } else if (
      targetType === 'Residence' &&
      this.hasBulkResidenceSelectTarget
    ) {
      this.bulkResidenceSelectTarget.classList.remove('d-none');
      const select = this.bulkResidenceSelectTarget.querySelector('select');
      if (select) select.disabled = false;
      this.#enableChoicesListsPlaceholder(this.bulkResidenceSelectTarget);
    }
  }

  #enableChoicesListsPlaceholder(container) {
    container.querySelectorAll('.choices__item--selectable').forEach((el) => {
      el.setAttribute('aria-disabled', 'false');
    });
  }
}
